import { useState } from 'react';

import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import { Modal } from '../Modal/Modal';

export interface IframeModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  url: string;
}

/** Displays a URL in a modal via an iframe, with a loading spinner until it loads. */
export function IframeModal({
  open,
  onClose,
  title,
  url,
}: Readonly<IframeModalProps>) {
  return (
    <Modal
      open={open}
      title={title}
      onCancel={onClose}
      footer={null}
      width={960}
      closable
    >
      {/* Mounted fresh each time the modal opens, so isLoading always starts true. */}
      {open && <IframeContent url={url} title={title} />}
    </Modal>
  );
}

function IframeContent({
  url,
  title,
}: Readonly<{ url: string; title?: string }>) {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div style={{ position: 'relative', height: '80vh' }}>
      {isLoading && <LoadingSpinner />}
      <iframe
        src={url}
        title={title ?? 'Directions'}
        onLoad={() => setIsLoading(false)}
        // allow-same-origin is required because the directions pages rely on
        // a cookie set at login on the legacy site for authentication.
        sandbox="allow-scripts allow-same-origin"
        referrerPolicy="strict-origin-when-cross-origin"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    </div>
  );
}
